import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FieldStates } from 'sos-common/js/commonTypes/formField.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';

import {
  addFileActionFunc,
  addFilesAction,
  removeFileActionFunc,
  removeFilesAction,
  setFormValue,
  clearErrorDispatcher,
  clearError,
} from 'sos-eservice-common/js/Redux/Actions';

import { getErrorMessageByFieldName, setInnerHtml } from 'sos-common/js/utils/helpers';
import { makeTranslator, translateFunc } from 'sos-common/js/utils/translations';
import { OmbudOrderModel } from '../models/OmbudOrderModel';
import { OmbudFormStore } from '../models/OmbudStore';
import { StepOneEditableTexts } from '../models/OmbudFormGlobals';
import { Expander } from 'sos-common/js/components/Expander/Expander';

export interface Step1Props extends StepChildProps {
  Translate?: translateFunc;
  files: filesMap;
  validationResults: ValidationResult[];
  orderId: string;
  postFile: addFileActionFunc;
  deleteFile: removeFileActionFunc;
  setFormValue?: typeof setFormValue;
  formModel: OmbudOrderModel;
  clearError: clearError;
  firstName: string;
  lastName: string;
  errors: ClientErrorsState;
  stepOneEditableTexts?: StepOneEditableTexts;
}

export interface Step1State {}

class Step1 extends React.Component<Step1Props, Step1State> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  public getTitle = () => 'Villkor';

  public addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  };
  public removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };

  public onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  };

  public componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  public render() {
    const { Translate, formModel, files, orderId, firstName, lastName, validationResults, stepOneEditableTexts } =
      this.props;
    const noOrderId = !orderId;

    return (
      <div id="step1" tabIndex={-1}>
        <div className="form-group" />
        <div dangerouslySetInnerHTML={setInnerHtml(stepOneEditableTexts.VillkorText)} />
        <hr className="formdivider" />
        <div dangerouslySetInnerHTML={setInnerHtml(stepOneEditableTexts.AnsvarText)} />
        {stepOneEditableTexts.ExpandBoxOneHeading && (
          <Expander heading={stepOneEditableTexts.ExpandBoxOneHeading} isExpanded={false}>
            <div dangerouslySetInnerHTML={setInnerHtml(stepOneEditableTexts.ExpandBoxOneText)} />
          </Expander>
        )}
        {stepOneEditableTexts.ExpandBoxTwoHeading && (
          <Expander heading={stepOneEditableTexts.ExpandBoxTwoHeading} isExpanded={false}>
            <div dangerouslySetInnerHTML={setInnerHtml(stepOneEditableTexts.ExpandBoxTwoText)} />
          </Expander>
        )}
        {stepOneEditableTexts.ExpandBoxThreeHeading && (
          <Expander heading={stepOneEditableTexts.ExpandBoxThreeHeading} isExpanded={false}>
            <div dangerouslySetInnerHTML={setInnerHtml(stepOneEditableTexts.ExpandBoxThreeText)} />
          </Expander>
        )}
        <hr className="formdivider formdivider--m-b-none" />
        <div className="terms-wrapper">
          <CheckBox
            id="AccepteratVillkorCheckbox"
            fieldName="AccepteratVillkor"
            label={Translate('|OmbudsansokanForm|intygan') + ' *'}
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(validationResults, 'AccepteratVillkor')}
            value={_.get(formModel, 'AccepteratVillkor')}
          />
        </div>
        <hr className="formdivider formdivider--m-t-none formdivider--m-b-small" />
      </div>
    );
  }
}

const mapState2Props = (state: OmbudFormStore) => {
  const { errors, files, formModel, globals, validationState } = state;
  const { orderId, firstName, lastName, translations, stepOneEditableTexts } = globals;
  return {
    errors: errors,
    files: files,
    formModel: formModel,
    orderId: orderId,
    firstName: firstName,
    lastName: lastName,
    stepValidationMap: validationState.stepValidationMap,
    Translate: makeTranslator(translations),
    validationResults: validationState.validationResults,
    stepOneEditableTexts: stepOneEditableTexts,
  } as Partial<Step1Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    clearError: clearErrorDispatcher(dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    setFormValue: bindActionCreators(setFormValue, dispatch),
  };
};

const StepOne = connect(mapState2Props, mapDispatch2Props)(Step1);
export { StepOne };
